import React, { useState, useRef, useEffect } from "react";

/* ── Image imports ── */
import HeroBgImg        from "../../../asset/images/defenceNew/hero-bg.webp";
import BcSepIcon        from "../../../asset/images/about/breadcrumb-separator.svg";


/* Product tab images */
import UpsImg           from "../../../asset/images/defenceNew/ups-system.webp";
import UpsImg2          from "../../../asset/images/defenceNew/ups-system2.webp";
import ItuImg           from "../../../asset/images/defenceNew/itu1.webp";
import ItuImg2          from "../../../asset/images/defenceNew/itu2.webp";
import CpsImg           from "../../../asset/images/defenceNew/cps.webp";
import CpsImg2          from "../../../asset/images/defenceNew/cps2.webp";
import PdbImg           from "../../../asset/images/defenceNew/pdb.webp";
import AtsImg           from "../../../asset/images/defenceNew/ats.webp";
import BcImg            from "../../../asset/images/defenceNew/battery-charger.webp";
import VsImg            from "../../../asset/images/defenceNew/voltage-stabilizer.webp";
import SbcImg           from "../../../asset/images/defenceNew/submarine-battery-charger.webp";

/* Products Under Development */
import PudImg           from "../../../asset/images/defenceNew/pud-product.webp";
import PudImg2a from "../../../asset/images/defenceNew/pud-product2a.png";
import PudImg2b from "../../../asset/images/defenceNew/pud-product2b.png";
import PudImg3 from "../../../asset/images/defenceNew/pud-product3.png";

/* Awards */
import Award1           from "../../../asset/images/defenceNew/award-1.webp";
import Award2           from "../../../asset/images/defenceNew/award-2.webp";
import Award3           from "../../../asset/images/defenceNew/award-3.webp";

/* Certification logos */
import CertAs           from "../../../asset/images/defenceNew/cert-as9100.webp";
import CertNqa          from "../../../asset/images/defenceNew/cert-nqa.png";
import CertIso9001a     from "../../../asset/images/defenceNew/cert-iso9001.png";
import CertIso14001     from "../../../asset/images/defenceNew/cert-iso14001.png";
import CertIso39001     from "../../../asset/images/defenceNew/cert-iso39001.png";
import CertIso27001     from "../../../asset/images/defenceNew/cert-iso27001.png";
import CertCmmi         from "../../../asset/images/defenceNew/cert-cmmi.png";
import CertBis          from "../../../asset/images/defenceNew/cert-bis.png";
import CertCe           from "../../../asset/images/defenceNew/cert-ce.png";
import CertIso9001b     from "../../../asset/images/defenceNew/cert-iso9001b.png";
import CertRohs         from "../../../asset/images/defenceNew/cert-rohs.png";

/* Trusted-by logos – Row 1 */
import LogoArmyOrd      from "../../../asset/images/defenceNew/logo-army-ord.webp";
import LogoBel          from "../../../asset/images/defenceNew/logo-bel.png";
import LogoAccurate     from "../../../asset/images/defenceNew/logo-accurate.png";
import LogoBsf          from "../../../asset/images/defenceNew/logo-bsf.png";
import LogoRdso         from "../../../asset/images/defenceNew/logo-rdso.png";
import LogoEcil         from "../../../asset/images/defenceNew/logo-ecil.png";
import LogoDhLtd        from "../../../asset/images/defenceNew/logo-dh-ltd.png";
import LogoNavy         from "../../../asset/images/defenceNew/logo-navy.png";
/* Row 2 */
import LogoNfc          from "../../../asset/images/defenceNew/logo-nfc.png";
import LogoVecc         from "../../../asset/images/defenceNew/logo-vecc.png";
import LogoRrcat        from "../../../asset/images/defenceNew/logo-rrcat.png";
import LogoBarc         from "../../../asset/images/defenceNew/logo-barc.png";
import LogoDrdo         from "../../../asset/images/defenceNew/logo-drdo.png";
import LogoHemrl        from "../../../asset/images/defenceNew/logo-hemrl.png";
import LogoLt           from "../../../asset/images/defenceNew/logo-lt.png";
/* Row 3 */
import LogoArmy         from "../../../asset/images/defenceNew/logo-army.png";
import LogoBhel         from "../../../asset/images/defenceNew/logo-bhel.png";
import LogoIpr          from "../../../asset/images/defenceNew/logo-ipr.png";
import LogoClt          from "../../../asset/images/defenceNew/logo-clt.png";
import LogoElbit        from "../../../asset/images/defenceNew/logo-elbit.png";
import LogoReliance     from "../../../asset/images/defenceNew/logo-reliance.png";
import LogoIai          from "../../../asset/images/defenceNew/logo-iai.png";
import LogoAirForce     from "../../../asset/images/defenceNew/logo-airforce.png";

/* CTA background */
import CtaBgImg         from "../../../asset/images/defenceNew/cta-bg.webp";

/* ═══════════════════════════════════════════
   STATIC DATA
═══════════════════════════════════════════ */
const capabilities = [
  "Mission-Critical Power Expertise AC-DC & DC-DC Power Supply, UPS, Isolation transformers, and power systems for defence applications",
  "Rugged & Reliable Design Built for extreme environments with high reliability and redundancy",
  "Custom Engineering Tailored solutions for program-specific defence requirements",
  "System Integration Capability Seamless integration with radar, missile, naval, and EW systems",
  "Multi-chemistry battery integration capability Li-Ion, Gel, PLT, SMF",
  "Lifecycle Support & After-Sales Service",
];

const defenceApps = [
  "Radar Systems",
  "Missile Systems",
  "Naval & Submarine Platforms",
  "Road & Rail Mobile Launcher Systems",
  "Communication Shelters",
  "Weapon Systems",
  "Command & Control Systems",
  "Strategic Defence Infrastructure",
];

const tabs = [
  { id: "ups", label: "UPS Systems" },
  { id: "itu", label: "Isolation Transformer Units (ITU)" },
  { id: "cps", label: "Customized Power Supply" },
  { id: "pdb", label: "Power Distribution Boards (PDB)" },
  { id: "ats", label: "Automatic Transfer Switch (ATS)" },
  { id: "bc",  label: "Battery Charger For Li-Ion Batteries" },
  { id: "vs",  label: "Voltage Stabilizer" },
  { id: "sbc", label: "Submarine Battery Charger" },
];

/* ── images[] replaces img — add more slides per product when assets are ready ── */
const products = [
  {
    id: "ups",
    name: "UPS Systems",
    tagline: "Reliable Power. Mission Continuity.",
    desc: "ADOR's defence-grade UPS systems are engineered to ensure uninterrupted power for critical defence and naval operations. Designed for extreme environments, these systems deliver consistent performance where failure is not an option.",
    features: [
      "Wide range from 3kVA to 30kVA",
      "Built for harsh environments (−30°C to +55°C)",
      "Advanced battery options (SMF & Li-Ion)",
      "Proven in Radar and Weapon Systems",
      "Compliant with JSS55555/MIL810H and MIL-STD-461 E/F/G standards",
    ],
    images: [UpsImg, UpsImg2],   /* replace 2nd entry with real 2nd image when available */
  },
  {
    id: "itu",
    name: "Isolation Transformer Units (ITU)",
    tagline: "Precision Power for Critical Systems.",
    desc: "Our Isolation Transformer Units provide safe, stable and noise-free power for sensitive defence electronics and strategic systems.",
    features: [
      "Flexible configurations up to 200kVA",
      "Designed for complex defence platforms",
      "High reliability and safety assurance",
      "Compatible with multiple defence system requirements",
    ],
    images: [ItuImg, ItuImg2],
  },
  {
    id: "cps",
    name: "Customized Power Supply",
    tagline: "Tailored Power Solutions for Specialized Missions.",
    desc: "ADOR delivers customized power systems engineered for mission-specific defence requirements with seamless integration and enhanced operational reliability.",
    features: [
      "Compact 19” rack-mounted solutions",
      "Insulation Monitoring and Emergency Stop Features",
      "Integrated Communication Units",
      "Built-in safety and control architecture",
    ],
    images: [CpsImg, CpsImg2],
  },
  {
    id: "pdb",
    name: "Power Distribution Boards (PDB)",
    tagline: "Smart Power Distribution with Maximum Protection.",
    desc: "Our power distribution boards ensure safe, reliable and efficient power distribution across defence platforms.",
    features: [
      "Integrated overload and fault protection",
      "Ruggedized construction",
      "Real-time monitoring capability",
      "Suitable for shipboard and shelter applications",
    ],
    images: [PdbImg],
  },
  {
    id: "ats",
    name: "Automatic Transfer Switch (ATS)",
    tagline: "",
    desc: "An Automatic Transfer Switch (ATS) is a system that automatically transfers electrical load between two power sources when one source fails or goes out of limits.",
    features: [
      "Automatic Source Changeover",
      "Fast changeover time upto <10ms",
      "Source priority logic",
      "Break before make protection",
      "Manual Override",
      "Intelligent controller / MCU based logic",
      "Adjustable timer",
      "Electrical Protections",
      "Communication & Monitoring",
      "Status Indicator",
    ],
    images: [AtsImg],
  },
  {
    id: "bc",
    name: "Battery Charger For Li-Ion Batteries",
    tagline: "Reliable Charging. Redundant Power Assurance.",
    desc: "Engineered for defence mobile launcher and mission-critical systems, our charger systems ensure uninterrupted charging with redundancy architecture.",
    features: [
      "Input Supply: 30V DC",
      "Output Charging Current: 60",
      "Master & Slave redundancy architecture",
      "Designed for Road & Rail Mobile Launcher applications",
      "Operates in harsh environments (-30°C to +55°C)",
      "Compliant with JSS55555 Rev.03 and MIL-STD-461E standards",
    ],
    images: [BcImg],
  },
  {
    id: "vs",
    name: "Voltage Stabilizer",
    tagline: "",
    desc: "Advanced static voltage stabilizers engineered to deliver precise and continuous voltage regulation for sensitive electrical and industrial systems. Designed for high reliability, fast response, and efficient performance in demanding operating environments.",
    features: [
      "Fast and accurate voltage stabilization",
      "Solid-state design with no moving parts",
      "High efficiency and reliable performance",
      "Protection against voltage fluctuations and surges",
      "Compact and robust construction",

    ],
    images: [VsImg],
  },
  {
    id: "sbc",
    name: "Submarine Battery Charger",
    tagline: "High-Capacity Charging for Submarine Operations.",
    desc: "Mobile battery charging systems designed for demanding submarine and naval operations.",
    features: [
      "High power capacity up to 875kW",
      "Built for naval operating environments",
      "Reliable and efficient charging performance",
      
    ],
    images: [SbcImg],
  },
];

const pudItems = [
  "Dual Static Converter",
  "High-Power Water-Cooled Supply Modules",
  "Advanced AC-DC Power Supply Systems",
];

const whyPoints = [
  "118+ years of engineering legacy",
  "Custom-designed Solutions for Mission-Specific Requirements",
  "Trusted by Indian Navy, Air Force, Army & DRDO",
  "DSIR-certified R&D with in-house Design & Engineering capability",
  "Proven experience in Defence power systems",
  "Compliance with military and EMI/EMC standards",
  "Expertise in ruggedized and water-cooled systems",
  "High reliability and redundancy-focused design",
  "Strong lifecycle and after-sales support",
  "Fast engineering response and integration capability",
];

const awards = [
  { img: Award1, alt: "BEL Award Letter" },
  { img: Award2, alt: "Partnership Recognition Award 2020-21" },
  { img: Award3, alt: "IAI WCS Maintenance Practical Course" },
];

const certifications = [
  { img: CertAs,       alt: "AS 9100:2016"      },
  { img: CertNqa,      alt: "NQA ANAB ISO 9001"  },
  { img: CertIso9001a, alt: "ISO 9001:2015"      },
  { img: CertIso14001, alt: "ISO 14001:2015"     },
  { img: CertIso39001, alt: "ISO 39001:2012"     },
  { img: CertIso27001, alt: "ISO 27001"          },
  { img: CertCmmi,     alt: "CMMI Level 4"       },
  { img: CertBis,      alt: "BIS"                },
  { img: CertCe,       alt: "CE"                 },
  { img: CertIso9001b, alt: "ISO 9001:2015"      },
  { img: CertRohs,     alt: "RoHS Compliant"     },
];

/* ═══════════════════════════════════════════
   CSS
═══════════════════════════════════════════ */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .dpow { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  .dpow-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* 1. HERO */
  .dpow-hero { position: relative; width: 100%; height: 600px; overflow: hidden; }
  .dpow-hero-bg { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; object-position: center; display: block; }
  /* .dpow-hero-overlay { position: absolute; inset: 0; background: linear-gradient(to right, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.35) 60%, rgba(0,0,0,0.10) 100%); } */
  .dpow-hero-content { position: absolute; inset: 0; display: flex; align-items: center; }
  .dpow-hero-content-inner { width: 100%; max-width: 1600px; margin: 0 auto; padding: 0 102px; display: flex; flex-direction: column; justify-content: center; }
  .dpow-hero-title { font-family: 'Poppins', sans-serif; font-size: 42px; font-weight: 600; color: #fff; line-height: 120%; margin-bottom: 15px; }
  .dpow-hero-divider { width: 673px; height: 2px; background: #EB2019; border: none; margin-bottom: 15px; }
  .dpow-hero-subtitle { font-family: 'Poppins', sans-serif; font-size: 16px; font-weight: 400; color: #fff; line-height: 140%; max-width: 673px; margin-bottom: 20px; }
  .dpow-btn-primary { display: inline-block; padding: 14px 24px; background: #EB2019; color: #fff; font-family: 'DM Sans', sans-serif; font-size: 16px; font-weight: 500; border: none; border-radius: 10px; cursor: pointer; text-decoration: none; width: fit-content; transition: background 0.15s; display:none;}
  .dpow-btn-primary:hover { color: #202020; } 

  /* 2. BREADCRUMB */
  .dpow-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .dpow-breadcrumb-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; display: flex; align-items: center; flex-wrap: wrap; }
  .dpow-bc-item { font-family: 'Poppins', sans-serif; font-size: 16px; font-weight: 500; color: #202020; text-decoration: none; display: flex; align-items: center; gap: 14px; transition: color 0.15s; }
  .dpow-bc-item:hover { color: #EB2019; }
  .dpow-bc-sep  { display: flex; align-items: center; justify-content: center; width: 24px; height: 24px; border-radius: 50%; margin: 0 8px; flex-shrink: 0; }
  .dpow-bc-active { font-size: 16px; font-weight: 500; color: #202020; }

  /* 3. ABOUT */
  .dpow-about-section { padding: 80px 0 100px; }
  .dpow-about-heading { font-family: 'Poppins', sans-serif; font-size: 32px; font-weight: 600; color: #EB2019; margin-bottom: 20px; }
  .dpow-about-sub { font-family: 'Poppins', sans-serif; font-size: 18px; font-weight: 500; color: #000000; margin-bottom: 20px; }
  .dpow-about-body { font-family: 'Poppins', sans-serif; font-size: 16px; font-weight: 400; color: #000000; line-height: 160%; margin-bottom: 20px; max-width: 1000px; }
  .dpow-about-body2 { font-family: 'Poppins', sans-serif; font-size: 16px; font-weight: 400; color: #000000; line-height: 160%; margin-bottom: 0px; max-width: 1000px; }
  .dpow-cap-row { display: grid; grid-template-columns: 1fr 1fr; gap: 30px; margin-top: 80px; }
  .dpow-cap-card { background: #F2F5FA; border-radius: 10px; padding: 50px 60px; }
  .dpow-cap-title { font-family: 'Poppins', sans-serif; font-size: 24px; font-weight: 600; letter-spacing: 1%; color: #202020; text-transform: uppercase; margin-bottom: 30px; }
  .dpow-cap-list { list-style: none; display: flex; flex-direction: column; gap: 24px; }
  .dpow-cap-list li { display: flex; gap: 13px; align-items: flex-start; font-family: 'Poppins', sans-serif; font-size: 18px; font-weight: 400; color: #202020; line-height: 160%; }
  .dpow-cap-icon { flex-shrink: 0; width: 24px; height: 24px; margin-top: 4px; }

  /* 4. PRODUCT TABS */
  .dpow-tabs-bar { background: #EB2019; }
  .dpow-tabs-bar-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 211px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
  .dpow-tab-btn {
    padding: 20px 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    background: transparent;
    border: 0.5px solid #A40000;
    cursor: pointer;
    white-space: nowrap;
    text-align: center;
    transition: background 0.15s;
  }
  .dpow-tab-btn:hover, .dpow-tab-btn.active { background: #B71C1C; }

  .dpow-product-section { padding: 80px 0 80px; }
  .dpow-product-row { display: flex; align-items: center; gap: 80px; }
  .dpow-product-left { flex: 1; padding-top: 10px; }
  .dpow-product-name { font-family: 'Poppins', sans-serif; font-size: 32px; font-weight: 600; color: #EB2019; margin-bottom: 24px; }
  .dpow-product-tagline { font-family: 'Poppins', sans-serif; font-size: 20px; font-weight: 600; color: #202020; margin-bottom: 14px; }
  .dpow-product-desc { font-family: 'Poppins', sans-serif; font-size: 16px; color: #444; line-height: 140%; margin-bottom: 34px; max-width: 766px; }
  .dpow-features-label { display: inline-block; padding: 18px 27px 17px 34px; border-left: 10px solid #EB2019; font-family: 'Poppins', sans-serif; font-size: 16px; font-weight: 600; color: #202020; background: #FFE6E5; margin-bottom: 34px; }
  .dpow-product-features { list-style: none; display: flex; flex-direction: column; gap: 0px; }
  .dpow-product-features li { font-family: 'Poppins', sans-serif; font-size: 16px; color: #202020; line-height: 160%; padding-left: 18px; position: relative; }
  .dpow-product-features li::before { content: '•'; position: absolute; left: 0; color: #202020; }

  /* ── CAROUSEL ── */
  .dpow-product-right {
    flex: 0 0 550px;
    border-radius: 10px;
    background: #F5F5F5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    min-height: 600px;
  }
  .dpow-carousel {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
  .dpow-carousel-track {
    position: relative;
    width: 100%;
    height: 450px;
    overflow: hidden;
    cursor: grab;
    user-select: none;
  }
  .dpow-carousel-track:active { cursor: grabbing; }
  .dpow-carousel-strip {
    display: flex;
    height: 100%;
    transition: transform 0.35s ease;
    will-change: transform;
  }
  .dpow-carousel-strip.no-transition { transition: none; }
  .dpow-carousel-slide {
    flex: 0 0 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dpow-product-img {
    width: 100%;
    height: 450px;
    object-fit: contain;
    display: block;
    pointer-events: none;
    -webkit-user-drag: none;
  }
  .dpow-carousel-dots {
    display: flex;
    gap: 8px;
  }
  .dpow-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ccc;
    cursor: pointer;
    border: none;
    padding: 0;
    transition: background 0.2s;
  }
  .dpow-dot.active { background: #EB2019; }

  /* DIVIDER */
  .dpow-divider-wrap { max-width: 1600px; margin: 0 auto; padding: 0 102px; }
  .dpow-divider { border: none; border-top: 1px solid #f0a0a0; margin: 0; }

  /* 5. PRODUCTS UNDER DEVELOPMENT */
  .dpow-pud-section { padding: 80px 0 100px; }
  .dpow-pud-row { display: flex; align-items: center; gap: 80px; }
  .dpow-pud-left { flex: 0 0 550px; border-radius: 10px; background: #f9f9f9; display: flex; align-items: center; justify-content: center; padding: 25px; min-height: 600px; }
  .dpow-pud-img { width: 100%; height: 325px; object-fit: contain; display: block; }
  .dpow-pud-right { flex: 1; }
  .dpow-pud-heading { font-family: 'Poppins', sans-serif; font-size: 32px; font-weight: 600; color: #EB2019; margin-bottom: 24px; line-height: 120%; }
  .dpow-pud-tagline { font-family: 'Poppins', sans-serif; font-size: 20px; font-weight: 600; color: #202020; margin-bottom: 14px; }
  .dpow-pud-desc { font-family: 'Poppins', sans-serif; font-size: 16px; color: #7A7A7A; line-height: 140%; margin-bottom: 30px; }
  .dpow-pud-list { display: flex; flex-direction: column; gap: 20px; }
  .dpow-pud-item { background: #FFE6E5; border-radius: 0px; padding: 30px; font-family: 'Poppins', sans-serif; font-size: 20px; font-weight: 500; color: #202020; border-left: 10px solid #EB2019; }

  /* 6. WHY ADOR POWERTRON */
  .dpow-why-section { padding: 80px 0 100px; }
  .dpow-why-heading { font-family: 'Poppins', sans-serif; font-size: 32px; font-weight: 600; color: #EB2019; text-align: center; margin-bottom: 60px; }
  .dpow-why-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 30px; }
  .dpow-why-card { background: #F2F5FA; border-radius: 10px; padding: 30px; font-family: 'Poppins', sans-serif; font-size: 20px; font-weight: 400; color: #202020; line-height: 140%; min-height: 144px; }

  /* 7. TRUSTED BY */
  .dpow-trusted-section { padding: 80px 0 80px; }
  .dpow-trusted-heading { font-family: 'Poppins', sans-serif; font-size: 32px; font-weight: 600; color: #202020; text-align: center; margin-bottom: 20px; }
  .dpow-trusted-sub { font-family: 'Poppins', sans-serif; font-size: 16px; color: #202020; text-align: center; line-height: 160%; max-width: 758px; margin: 0 auto 60px; }
  .dpow-logo-row { display: grid; grid-template-columns: repeat(5, 1fr); gap: 30px; margin-bottom: 22px; }
  .dpow-logo-row.row-7 { grid-template-columns: repeat(7, 1fr); }
  .dpow-logo-col { display: flex; flex-direction: column; gap: 16px; }
  .dpow-logo-card {
    border: 1px solid #C3C3C3;
    border-radius: 10px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 110px;
    flex: 1;
  }
  /* shared base — overridden per logo below */
  .dpow-logo-img { max-width: 120px; max-height: 70px; object-fit: contain; display: block; }

  /* ── individual logo size controls ── */
  .dpow-logo-army-ord  { max-width: 142px; max-height: 142px; }
  .dpow-logo-bel       { max-width: 205px; max-height: 78px;  }
  .dpow-logo-accurate  { max-width: 149px; max-height: 69px;  }
  .dpow-logo-bsf       { max-width: 97px;  max-height: 102px; }
  .dpow-logo-rdso      { max-width: 79px;  max-height: 93px;  }
  .dpow-logo-ecil      { max-width: 102px; max-height: 82px;  }
  .dpow-logo-dh-ltd    { max-width: 172px; max-height: 62px;  }
  .dpow-logo-navy      { max-width: 97px;  max-height: 145px; }
  .dpow-logo-nfc       { max-width: 96px;  max-height: 99px;  }
  .dpow-logo-vecc      { max-width: 96px;  max-height: 99px;  }
  .dpow-logo-rrcat     { max-width: 96px;  max-height: 99px;  }
  .dpow-logo-barc      { max-width: 96px;  max-height: 99px;  }
  .dpow-logo-drdo      { max-width: 96px;  max-height: 99px;  }
  .dpow-logo-hemrl     { max-width: 96px;  max-height: 99px;  }
  .dpow-logo-lt        { max-width: 96px;  max-height: 99px;  }
  .dpow-logo-army      { max-width: 135px; max-height: 132px; }
  .dpow-logo-bhel      { max-width: 102px; max-height: 84px;  }
  .dpow-logo-ipr       { max-width: 107px; max-height: 82px;  }
  .dpow-logo-clt       { max-width: 214px; max-height: 59px;  }
  .dpow-logo-elbit     { max-width: 167px; max-height: 59px;  }
  .dpow-logo-reliance  { max-width: 173px; max-height: 73px;  }
  .dpow-logo-iai       { max-width: 111px; max-height: 73px;  }
  .dpow-logo-airforce  { max-width: 124px; max-height: 139px; }

  /* 8. AWARDS */
  .dpow-awards-section { padding: 80px 0 80px; }
  .dpow-awards-heading { font-family: 'Poppins', sans-serif; font-size: 32px; font-weight: 600; color: #EB2019; text-align: center; margin-bottom: 60px; }
  .dpow-awards-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 30px; }
  .dpow-award-img { width: 100%; aspect-ratio: 4 / 3; object-fit: cover; border-radius: 0px; display: block; height: 564px; }

  /* 9. CERTIFICATIONS */
  .dpow-cert-section { padding: 60px 0 80px; }
  .dpow-cert-row { display: flex; align-items: flex-start; gap: 90px; }
  .dpow-cert-label-col { flex: 0 0 426px; padding-top: 8px; }
  .dpow-cert-label-text { font-family: 'Poppins', sans-serif; font-size: 32px; font-weight: 600; color: #202020; line-height: 140%; }
  .dpow-cert-logos-col {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  /* each row of 4 logos */
  .dpow-cert-row-group {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0;
    align-items: center;
    padding-bottom: 30px;
    margin-bottom: 30px;
    position: relative;
  }
  /* gradient bottom border on row 1 and row 2 only */
  .dpow-cert-row-group.has-border::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(to right, #FFFFFF 0%, #5D5D5D 100%);
  }
  /* last row — no border, no bottom padding/margin */
  .dpow-cert-row-group:last-child {
    padding-bottom: 0;
    margin-bottom: 0;
  }
  .dpow-cert-logo-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }
  .dpow-cert-img { max-width: 110px; max-height: 110px; object-fit: contain; display: block; }

  /* 10. CTA BANNER */
  .dpow-cta-section { position: relative; overflow: hidden; min-height: 450px; display: flex; align-items: center; }
  .dpow-cta-bg { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; object-position: center; display: block; }
  .dpow-cta-overlay { position: absolute; inset: 0; background: linear-gradient(to right, rgba(0,0,0,0.80) 0%, rgba(0,0,0,0.52) 55%, rgba(0,0,0,0.20) 100%); }
  /* FIX: cta-inner constrains content to 1600px + 102px — same pattern as dpow-inner */
  .dpow-cta-inner { position: relative; z-index: 1; width: 100%; max-width: 1600px; margin: 0 auto; padding: 50px 102px; }
  .dpow-cta-title { font-family: 'Poppins', sans-serif; font-size: 32px; font-weight: 600; color: #fff; line-height: 140%; margin-bottom: 20px; max-width: 730px; }
  .dpow-cta-btns { display: flex; gap: 20px; flex-wrap: wrap; }
  .dpow-btn-outline { display: inline-block; padding: 14px 28px; color: #fff; background: #EB2019; font-family: 'Poppins', sans-serif; font-size: 14px; font-weight: 500; border-radius: 10px; cursor: pointer; text-decoration: none; transition: background 0.15s, color 0.15s; }
  .dpow-btn-outline:hover { color: #202020; }

  /* 11. GET IN TOUCH */
  .dpow-contact-section { padding: 100px 0 100px; }
  .dpow-contact-row { display: flex; gap: 100px; align-items: center; max-width:1051px;justify-content:center;margin:0 auto;}
  .dpow-contact-left { flex: 1; }
  .dpow-contact-heading { font-family: 'Poppins', sans-serif; font-size: 32px; font-weight: 600; color: #202020; margin-bottom: 14px; }
  .dpow-contact-tagline { font-family: 'Poppins', sans-serif; font-size: 14px; color: #000000; margin-bottom: 24px; line-height: 160%; }
  .dpow-contact-detail { display: flex; gap: 14px; align-items: flex-start; margin-bottom: 24px; }
  .dpow-contact-icon { flex-shrink: 0; width: 22px; height: 22px; margin-top: 2px; }
  .dpow-contact-detail-text { font-family: 'Poppins', sans-serif; font-size: 16px; color: #202020; line-height: 160%; }
  /* form card — white box with border + shadow matching screenshot */
  .dpow-contact-right {
    flex: 0 0 513px;
    background: #F5F5F5;
   
    border-radius: 10px;
    padding: 30px;
    
  }
  .dpow-form-row { display: flex; gap: 15px; margin-bottom: 14px; }
  .dpow-form-input {
    flex: 1;
    padding: 13px 14px;
    
    border-radius: 5px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    color: #74767A;
    outline: none;
    background: #fff;
     border:1px solid #F5F5F5;
    width: 100%;
    transition: border-color 0.15s;
   
  }
  .dpow-form-input:focus { border-color: #EB2019; }
  .dpow-form-textarea {
    width: 100%;
     padding: 13px 14px;
    min-height: 120px;
    resize: vertical;
   border:1px solid #F5F5F5;
    border-radius: 6px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    color: #74767A;
    outline: none;
    margin-bottom: 20px;
    display: block;
    transition: border-color 0.15s;
  }
  .dpow-form-textarea:focus { border-color: #EB2019; }
  .dpow-btn-submit {
    width: 100%;
    padding: 16px;
    background: #EB2019;
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.15s;
  }
  .dpow-btn-submit:hover { background: #c91a12; }

 /* PUD tab active/inactive state */
.dpow-pud-item { cursor: pointer; transition: border-color 0.15s, background 0.15s; border-left: 10px solid transparent; }
.dpow-pud-item--active { border-left: 10px solid #EB2019; }

/* PUD dots */
.dpow-pud-left { flex-direction: column; gap: 16px; }
.dpow-pud-dots { display: flex; justify-content: center; gap: 8px; margin-top: 12px; }
.dpow-pud-dot {
  width: 8px; height: 8px; border-radius: 50%;
  background: #ccc; border: none; padding: 0;
  cursor: pointer; transition: background 0.2s;
}
  .dpow-pud-left { display: flex; flex-direction: column; align-items: center; justify-content: center; }
.dpow-pud-dot.active { background: #EB2019; }
.dpow-pud-dot.active { background: #EB2019; }
/* Tablet + Mobile */
@media (max-width: 768px) {
  .dpow-pud-row--reversed { flex-direction: column; }
}
@media (max-width: 480px) {
  .dpow-pud-row--reversed { flex-direction: column; }
}

/* MOBILE TAB BAR */
.dpow-mobile-bar {
  display: none;
  width: 100%;
  background: #B91E1A;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 56px;
  position: sticky;
  top: 0;
  z-index: 100;
}
.dpow-mobile-bar-title {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 50px);
}
.dpow-hamburger {
  display: flex;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 4px;
  flex-shrink: 0;
}
.dpow-hamburger span {
  display: block;
  width: 22px;
  height: 2px;
  background: #fff;
  border-radius: 2px;
}

/* SIDEBAR OVERLAY */
.dpow-sidebar-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  z-index: 500;
}
.dpow-sidebar-overlay.open { display: block; }

/* SIDEBAR DRAWER */
.dpow-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 300px;
  max-width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 600;
  display: flex;
  flex-direction: column;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
}
.dpow-sidebar.open { transform: translateX(0); }
.dpow-sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #B91E1A;
  padding: 0 20px;
  height: 56px;
  flex-shrink: 0;
}
.dpow-sidebar-header-title {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 40px);
}
.dpow-sidebar-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #fff;
  font-size: 22px;
  line-height: 1;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.dpow-sidebar-nav { flex: 1; overflow-y: auto; margin-top:20px; }
.dpow-sidebar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 26px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-bottom: 0.7px solid #d0d0d0;
  cursor: pointer;
  background: none;
  border-left: none;
  border-right: none;
  border-top: none;
  width: 100%;
  text-align: left;
}
.dpow-sidebar-row:hover { background: #fafafa; }
.dpow-sidebar-row.active { color: #EB2019; font-weight: 500; }
.dpow-sidebar-chevron {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-right: 2px solid #888;
  border-bottom: 2px solid #888;
  transform: rotate(-45deg);
  flex-shrink: 0;
  display:none;
}

/* Show mobile bar, hide desktop tab bar — mobile only */
@media (max-width: 480px) {
  .dpow-tabs-bar { display: none; }
  .dpow-mobile-bar { display: flex; }
}
  /* RESPONSIVE — TABLET */
  @media (max-width: 768px) {
    .dpow-hero              { height: 350px; }
    .dpow-hero-content-inner { padding: 0 32px; }
    .dpow-hero-title        { font-size: 28px; }
    .dpow-hero-divider      { width:450px; }
    .dpow-hero-subtitle { max-width: 450px;}
    
    .dpow-breadcrumb-inner  { padding: 0 32px; }
    .dpow-inner             { padding: 0 32px; }
   .dpow-breadcrumb { padding: 24px 0 0 0;}
    .dpow-tabs-bar-inner    { padding: 0 32px; grid-template-columns: repeat(2, 1fr); }
    .dpow-divider-wrap      { padding: 0 32px; }
    .dpow-about-heading { font-size: 24px; margin-bottom:14px;}
    .dpow-about-sub { font-size: 18px; margin-bottom:12px;}
    .dpow-about-body { margin-bottom:16px;}
    .dpow-about-section     { padding: 32px 0 40px; }
    .dpow-cap-row           { grid-template-columns: 1fr 1fr;margin-top: 32px; }
    .dpow-cap-card { padding: 24px;}
    .dpow-cap-title {  font-size: 18px;margin-bottom:18px; }
    .dpow-cap-list li { font-size: 16px; }
    .dpow-cap-list {     gap: 16px;}
    .dpow-cap-icon { width: 18px; height: 18px;}
    .dpow-product-section {     padding: 40px 0 40px;}
    .dpow-product-left { padding-top: 0px;}
    .dpow-product-row       { flex-direction: column; gap: 24px; }
    .dpow-product-right     { flex: none; width: 100%; }
    .dpow-product-name { font-size: 24px; margin-bottom:16px;}
    .dpow-product-desc { margin-bottom:16px;}
    .dpow-features-label { padding: 16px 24px 16px 28px;     margin-bottom: 18px;}
    .dpow-pud-section {     padding: 40px 0 40px;}
    .dpow-pud-row           { flex-direction: column; gap: 24px; }
    .dpow-pud-heading { font-size: 24px; margin-bottom:14px;}
    .dpow-pud-tagline { font-size: 18px; margin-bottom:12px;}
    .dpow-pud-item { padding: 24px; font-size: 18px;}
    .dpow-pud-list { gap: 16px;}
    .dpow-why-section {   padding: 40px 0 40px;}
    .dpow-why-heading { font-size: 24px; margin-bottom:14px;}
    .dpow-why-card { padding: 24px; font-size: 18px;}
    .dpow-pud-left          { flex: none; width: 100%; }
    .dpow-trusted-sub { margin: 0 auto 24px;}
    .dpow-why-grid          { grid-template-columns: repeat(2, 1fr); gap:24px;}
    .dpow-trusted-heading { font-size: 24px;margin-bottom: 16px;}
    .dpow-awards-section { padding: 40px 0 40px;}
    .dpow-awards-heading {font-size: 24px;margin-bottom: 18px;}
    .dpow-awards-grid       { grid-template-columns: 1fr 1fr; }
    .dpow-logo-army-ord  { max-width: 142px; max-height: 142px; }

  
    .dpow-cert-section { padding: 40px 0 40px;}
    .dpow-cert-label-text {     font-size: 24px;}
    .dpow-cert-row          { flex-direction: column; gap: 20px; }
    .dpow-cert-label-col    { flex: none; }
    .dpow-cert-row-group    { grid-template-columns: repeat(4, 1fr);padding-bottom: 20px;margin-bottom: 20px; }
    .dpow-contact-section {     padding: 40px 0 40px;}
    .dpow-contact-row       { flex-direction: column-reverse; max-width: 100%;align-items:flex-start; gap:24px; }
    
    .dpow-cta-title {     font-size: 24px;}
    .dpow-contact-left      { flex: none; width: 100%; }
    .dpow-contact-right     { flex: none; width: 100%; }
    .dpow-cta-inner         { padding: 40px 32px; }
    .dpow-contact-heading { font-size: 24px;}
    .dpow-contact-tagline { margin-bottom: 18px;}
    .dpow-contact-detail {margin-bottom: 18px;}
    .dpow-trusted-section   { padding: 40px 0 40px; }
    .dpow-logo-row          { grid-template-columns: repeat(3, 1fr);gap:24px; }
    .dpow-logo-row.row-7    { grid-template-columns: repeat(4, 1fr); }
  }

  /* RESPONSIVE — MOBILE */
  @media (max-width: 480px) {
    .dpow-hero              { height: 360px; }
    .dpow-hero-content-inner { padding: 0 16px; }
    .dpow-hero-title        { font-size: 24px; }
    .dpow-breadcrumb { padding: 42px 0 0 0;}
    .dpow-btn-primary {     padding: 14px 24px; width:100%;text-align:center;}
    .dpow-btn-outline {  padding: 14px 24px; width:100%;text-align:center;}
    .dpow-hero-subtitle { max-width: 370px;margin-bottom: 24px; }
    .dpow-hero-divider      { width: 370px; }
        .dpow-about-heading{ font-size: 20px; margin-bottom: 20px; }
        .dpow-about-sub {font-size: 16px; margin-bottom: 20px; }
            .dpow-about-body { font-size: 14px; margin-bottom: 20px; }
                .dpow-cap-row { margin-top: 40px;grid-template-columns: 1fr; gap: 20px;}
                    .dpow-cap-card { padding: 20px;}
        .dpow-cap-title { font-size: 20px; margin-bottom: 30px;}
            .dpow-cap-list li { font-size: 14px;}
                .dpow-cap-list { gap: 24px;}
                    .dpow-product-row {flex-direction: column-reverse;gap:20px;}
                    .dpow-product-right {min-height: 403px;}
                .dpow-carousel-track {height:auto;}
                .dpow-product-img {height: auto;}
                    .dpow-product-name { font-size: 20px;margin-bottom: 16px;}
                    .dpow-product-tagline {font-size: 16px;margin-bottom: 14px;}
                    .dpow-product-desc { font-size: 14px;margin-bottom: 20px;}
                        .dpow-features-label { padding: 18px 37px 19px 34px; font-size: 14px; margin-bottom: 20px;}
                        .dpow-product-features li { font-size: 14px;}
                            .dpow-pud-left { min-height: 400px;}
    .dpow-breadcrumb-inner  { padding: 0 16px; }
    .dpow-inner             { padding: 0 16px; }
    .dpow-tabs-bar-inner    { padding: 0 16px; grid-template-columns: repeat(2, 1fr); overflow-x: auto; }
    .dpow-divider-wrap      { padding: 0 16px; }
    .dpow-why-grid          { grid-template-columns: 1fr; }
        .dpow-why-card {min-height: 104px;font-size: 16px;align-items:center;justify-content:center;padding: 30px;}
    .dpow-awards-grid       { grid-template-columns: 1fr; gap:20px; }
    .dpow-form-row          { flex-direction: column; }
    .dpow-cta-inner         { padding: 36px 16px; }
    .dpow-cta-title         { font-size: 20px; }
    .dpow-logo-row          { grid-template-columns: repeat(2, 1fr); }
    .dpow-logo-row { display: grid;}
    .dpow-logo-row > *:last-child { grid-row: 1;   grid-column: 2;}
    .dpow-logo-col {flex-direction: column;}
    .dpow-logo-row.row-7    { grid-template-columns: repeat(2, 1fr); }
    .dpow-logo-card { min-height: 100px;}
    .dpow-logo-ecil {max-width: 70px; max-height: 57px;}
    .dpow-logo-row:last-child{margin-bottom:0px;}
        .dpow-trusted-sub { margin: 00 0 30px; text-align:left;}
        .dpow-trusted-heading { font-size: 20px;text-align:left; margin-bottom: 12px;}
    .dpow-pud-row           { flex-direction: column;gap:30px; }
        .dpow-pud-heading { font-size: 20px; margin-bottom: 14px;}
        .dpow-pud-tagline { font-size: 16px;}
        .dpow-pud-desc {font-size: 14px;}
            .dpow-pud-list {gap:20px;}
            .dpow-pud-item { padding: 20px 30px;font-size: 14px;}
            .dpow-why-heading { font-size: 20px; margin-bottom: 30px; text-align:left;}
                .dpow-awards-heading { font-size: 20px;text-align:left; margin-bottom: 30px;}
    .dpow-product-section   { padding: 40px 0 40px; }
    .dpow-why-section       { padding: 40px 0 40px; }
    .dpow-cert-section      { padding: 40px 0 40px; }
    .dpow-cert-row-group    { grid-template-columns: repeat(4, 1fr); gap: 10px; }
    .dpow-cert-logo-box {    padding: 5px;}
    .dpow-cert-img { max-width: 80px;max-height: 80px;}
    .dpow-contact-section   { padding: 40px 0 40px; }
        .dpow-cert-label-text {font-size: 20px;width:100%;}

    .dpow-logo-bel       { max-width: 141px; max-height: 54px;  }
    .dpow-logo-army-ord  { max-width: 97px; max-height: 97px; }
  .dpow-logo-accurate  { max-width: 103px; max-height: 47px;  }
  .dpow-logo-bsf       { max-width: 67px;  max-height: 71px; }
  .dpow-logo-rdso      { max-width: 54px;  max-height: 64px;  }
  .dpow-logo-ecil      { max-width: 102px; max-height: 82px;  }
  .dpow-logo-dh-ltd    { max-width: 172px; max-height: 62px;  }
  .dpow-logo-navy      { max-width: 67px;  max-height: 99px; }
  .dpow-logo-nfc       { max-width: 96px;  max-height: 99px;  }
  .dpow-logo-vecc      { max-width: 96px;  max-height: 99px;  }
  .dpow-logo-rrcat     { max-width: 96px;  max-height: 99px;  }
  .dpow-logo-barc      { max-width: 96px;  max-height: 99px;  }
  .dpow-logo-drdo      { max-width: 96px;  max-height: 99px;  }
  .dpow-logo-hemrl     { max-width: 96px;  max-height: 99px;  }
  .dpow-logo-lt        { max-width: 96px;  max-height: 99px;  }
  .dpow-logo-army      { max-width: 135px; max-height: 132px; }
  .dpow-logo-bhel      { max-width: 141px; max-height: 54px;  }
  .dpow-logo-ipr       { max-width: 107px; max-height: 82px;  }
  .dpow-logo-clt       { max-width: 214px; max-height: 59px;  }
  .dpow-logo-elbit     { max-width: 167px; max-height: 59px;  }
  .dpow-logo-reliance  { max-width: 173px; max-height: 73px;  }
  .dpow-logo-iai       { max-width: 111px; max-height: 73px;  }
  .dpow-logo-airforce  { max-width: 124px; max-height: 139px; }
      .dpow-contact-row { flex-direction: column;}
          .dpow-contact-right { padding: 20px;}
          .dpow-form-row { flex-direction: row; gap: 10px;}
          .dpow-btn-submit {    padding: 12px;}
              
  }
`;

/* ═══════════════════════════════════════════
   SHARED ICON COMPONENTS
═══════════════════════════════════════════ */
const CheckIcon = () => (
  <svg className="dpow-cap-icon" viewBox="0 0 20 20" fill="none">
    <circle cx="10" cy="10" r="10" fill="#EB2019"/>
    <path d="M6 10.5l2.5 2.5 5-5.5" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const BcArrow = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
    <path d="M2 1l3 3-3 3" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PinIcon = () => (
  <svg className="dpow-contact-icon" viewBox="0 0 16 16" fill="none">
    <path d="M8 1a5 5 0 0 1 5 5c0 3.5-5 9-5 9S3 9.5 3 6a5 5 0 0 1 5-5zm0 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" fill="#EB2019"/>
  </svg>
);

const PhoneIcon = () => (
  <svg className="dpow-contact-icon" viewBox="0 0 16 16" fill="none">
    <path d="M13.5 10.5l-2-2a1 1 0 0 0-1.4 0l-.8.8a9.2 9.2 0 0 1-3.6-3.6l.8-.8a1 1 0 0 0 0-1.4l-2-2A1 1 0 0 0 3 2C2 4 2 8 6 12s8 4 10 3a1 1 0 0 0 .5-1.5z" fill="#EB2019"/>
  </svg>
);

const MailIcon = () => (
  <svg className="dpow-contact-icon" viewBox="0 0 16 16" fill="none">
    <rect x="2" y="4" width="12" height="9" rx="1.5" stroke="#EB2019" strokeWidth="1.2"/>
    <path d="M2 5.5l6 4 6-4" stroke="#EB2019" strokeWidth="1.2"/>
  </svg>
);

/* ═══════════════════════════════════════════
   PRODUCT CAROUSEL  — drag + dot + tab-reset
═══════════════════════════════════════════ */
const ProductCarousel = ({ images, name }) => {
  const [current, setCurrent]       = useState(0);
  const [dragging, setDragging]     = useState(false);
  const [noAnim, setNoAnim]         = useState(false);
  const startX                      = useRef(0);
  const diffX                       = useRef(0);
  const trackRef                    = useRef(null);

  useEffect(() => {
    setNoAnim(true);
    setCurrent(0);
    setTimeout(() => setNoAnim(false), 20);
  }, [name]);

  if (!images || images.length === 0) return null;

  const total  = images.length;
  const goTo   = (idx) => setCurrent(Math.max(0, Math.min(idx, total - 1)));
  const offset = dragging ? `calc(${-current * 100}% + ${diffX.current}px)` : `${-current * 100}%`;

  const onPointerDown = (e) => {
    trackRef.current.setPointerCapture(e.pointerId);
    startX.current = e.clientX;
    diffX.current  = 0;
    setDragging(true);
    setNoAnim(true);
  };

  const onPointerMove = (e) => {
    if (!dragging) return;
    diffX.current = e.clientX - startX.current;
  };

  const onPointerUp = () => {
    if (!dragging) return;
    setDragging(false);
    setNoAnim(false);
    const threshold = 50;
    if (diffX.current < -threshold && current < total - 1) goTo(current + 1);
    else if (diffX.current > threshold && current > 0)     goTo(current - 1);
    diffX.current = 0;
  };

  return (
    <div className="dpow-carousel">
      <div
        ref={trackRef}
        className="dpow-carousel-track"
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerLeave={onPointerUp}
      >
        <div
          className={`dpow-carousel-strip${noAnim ? " no-transition" : ""}`}
          style={{ transform: `translateX(${offset})` }}
        >
          {images.map((src, idx) => (
            <div key={idx} className="dpow-carousel-slide">
              <img
                className="dpow-product-img"
                src={src}
                alt={`${name} ${idx + 1}`}
                draggable={false}
              />
            </div>
          ))}
        </div>
      </div>

      {total > 1 && (
        <div className="dpow-carousel-dots">
          {images.map((_, idx) => (
            <button
              key={idx}
              className={`dpow-dot${idx === current ? " active" : ""}`}
              onClick={() => goTo(idx)}
              aria-label={`Slide ${idx + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

/* ═══════════════════════════════════════════
   SECTION COMPONENTS
═══════════════════════════════════════════ */

/* ── 1. Hero ── */
const DpowHero = () => (
  <section className="dpow-hero">
    <img className="dpow-hero-bg" src={HeroBgImg} alt="Ador Defence Hero"/>
    <div className="dpow-hero-overlay"/>
    <div className="dpow-hero-content">
      <div className="dpow-hero-content-inner">
        <h1 className="dpow-hero-title">
          Engineered Power Systems For<br/>Strategic Defence Applications
        </h1>
        <hr className="dpow-hero-divider"/>
        <p className="dpow-hero-subtitle">
          Trusted power systems for Army, Navy, Air Force and strategic defence
          infrastructure — engineered for reliability in the harshest operational environments.
        </p>
      
      </div>
    </div>
  </section>
);

/* ── 2. Breadcrumb ── */
const DpowBreadcrumb = () => (
  <nav className="dpow-breadcrumb" aria-label="Breadcrumb">
    <div className="dpow-breadcrumb-inner">
      <a href="/" className="dpow-bc-item">Home</a>
      <span className="dpow-bc-sep"><img src={BcSepIcon} alt="" /></span>
      <a href="#" className="dpow-bc-item">Business</a>
      <span className="dpow-bc-sep"><img src={BcSepIcon} alt="" /></span>
      <span className="dpow-bc-active">Ador Defence</span>
    </div>
  </nav>
);

/* ── 3. About Defence Division ── */
const DpowAbout = () => (
  <section className="dpow-about-section">
    <div className="dpow-inner">
      <h2 className="dpow-about-heading">About Defence Division</h2>
      <p className="dpow-about-sub">Trusted Partner For Mission-Critical Defence Power Solutions</p>
      <p className="dpow-about-body">
        ADOR Powertron's Defence Division is a trusted partner in delivering advanced, ruggedized,
        and mission-critical power solutions for strategic defence platforms and infrastructure.
        Engineered to meet the demanding operational requirements of the Army, Navy, and Air Force,
        our systems are built to ensure uncompromising reliability, safety, and operational readiness
        in the most challenging environments.
      </p>
      <p className="dpow-about-body2">
        Backed by indigenous engineering excellence, strong in-house R&D capabilities, and deep
        expertise in MIL-grade power electronics, ADOR Powertron proudly contributes to some of
        India's most advanced and strategically significant defence programs, supporting the nation's
        vision for self-reliance and technological leadership in defence.
      </p>
      <div className="dpow-cap-row">
        <div className="dpow-cap-card">
          <div className="dpow-cap-title">Our Capabilities</div>
          <ul className="dpow-cap-list">
            {capabilities.map((item, idx) => (
              <li key={idx}><CheckIcon/>{item}</li>
            ))}
          </ul>
        </div>
        <div className="dpow-cap-card">
          <div className="dpow-cap-title">Defence Applications</div>
          <ul className="dpow-cap-list">
            {defenceApps.map((item, idx) => (
              <li key={idx}><CheckIcon/>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

/* ── 4. Product Tabs ── */
// const DpowProductTabs = ({ activeTab, setActiveTab }) => {
//   const activeProduct = products.find(p => p.id === activeTab);
//   return (
//     <section>
//       <div className="dpow-tabs-bar">
//         <div className="dpow-tabs-bar-inner">
//           {tabs.map(tab => (
//             <button
//               key={tab.id}
//               className={`dpow-tab-btn${activeTab === tab.id ? " active" : ""}`}
//               onClick={() => setActiveTab(tab.id)}
//             >
//               {tab.label}
//             </button>
//           ))}
//         </div>
//       </div>
//       <div className="dpow-product-section">
//         <div className="dpow-inner">
//           <div className="dpow-product-row">
//             <div className="dpow-product-left">
//               <div className="dpow-product-name">{activeProduct.name}</div>
//               <div className="dpow-product-tagline">{activeProduct.tagline}</div>
//               <p className="dpow-product-desc">{activeProduct.desc}</p>
//               <div className="dpow-features-label">FEATURES</div>
//               <ul className="dpow-product-features">
//                 {activeProduct.features.map((f, idx) => (
//                   <li key={idx}>{f}</li>
//                 ))}
//               </ul>
//             </div>
//             <div className="dpow-product-right">
//               <ProductCarousel images={activeProduct.images} name={activeProduct.name}/>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };
// 
const DpowProductTabs = ({ activeTab, setActiveTab }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const activeProduct = products.find(p => p.id === activeTab);
  const activeTabLabel = tabs.find(t => t.id === activeTab)?.label || "";

  const handleMobileSelect = (id) => {
    setActiveTab(id);
    setSidebarOpen(false);
  };

  return (
    <section>

      {/* Desktop + Tablet tab bar — unchanged */}
      <div className="dpow-tabs-bar">
        <div className="dpow-tabs-bar-inner">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`dpow-tab-btn${activeTab === tab.id ? " active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Mobile sticky bar */}
      <div className="dpow-mobile-bar">
        <span className="dpow-mobile-bar-title">{activeTabLabel}</span>
        <button
          className="dpow-hamburger"
          onClick={() => setSidebarOpen(true)}
          aria-label="Open product menu"
        >
          <span/><span/><span/>
        </button>
      </div>

      {/* Overlay */}
      <div
        className={`dpow-sidebar-overlay${sidebarOpen ? " open" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />

      {/* Drawer */}
      <div className={`dpow-sidebar${sidebarOpen ? " open" : ""}`}>
        <div className="dpow-sidebar-header">
          <span className="dpow-sidebar-header-title">{activeTabLabel}</span>
          <button
            className="dpow-sidebar-close"
            onClick={() => setSidebarOpen(false)}
          >✕</button>
        </div>
        <nav className="dpow-sidebar-nav">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`dpow-sidebar-row${activeTab === tab.id ? " active" : ""}`}
              onClick={() => handleMobileSelect(tab.id)}
            >
              {tab.label}
              <span className="dpow-sidebar-chevron"/>
            </button>
          ))}
        </nav>
      </div>

      {/* Product content — unchanged */}
      <div className="dpow-product-section">
        <div className="dpow-inner">
          <div className="dpow-product-row">
            <div className="dpow-product-left">
              <div className="dpow-product-name">{activeProduct.name}</div>
              <div className="dpow-product-tagline">{activeProduct.tagline}</div>
              <p className="dpow-product-desc">{activeProduct.desc}</p>
              <div className="dpow-features-label">FEATURES</div>
              <ul className="dpow-product-features">
                {activeProduct.features.map((f, idx) => (
                  <li key={idx}>{f}</li>
                ))}
              </ul>
            </div>
            <div className="dpow-product-right">
              <ProductCarousel images={activeProduct.images} name={activeProduct.name}/>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};
/* ── 5. Products Under Development ── */
// const DpowProductsUnderDev = () => (
//   <section className="dpow-pud-section">
//     <div className="dpow-inner">
//       <div className="dpow-pud-row">
//         <div className="dpow-pud-left">
//           <img className="dpow-pud-img" src={PudImg} alt="Product Under Development"/>
//         </div>
//         <div className="dpow-pud-right">
//           <h2 className="dpow-pud-heading">Products Under Development</h2>
//           <p className="dpow-pud-tagline">Innovating For The Future Of Defence Power.</p>
//           <p className="dpow-pud-desc">
//             ADOR continues to invest in next-generation defence power technologies to support
//             evolving mission requirements.
//           </p>
//           <div className="dpow-pud-list">
//             {pudItems.map((item, idx) => (
//               <div className="dpow-pud-item" key={idx}>{item}</div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   </section>
// );
const pudData = [
  {
    id: "dsc",
    label: "Dual Static Converter",
    images: [PudImg],
    imgAlt: "Dual Static Converter",
  },
  {
    id: "hpwc",
    label: "High-Power Water-Cooled Supply Modules",
    images: [PudImg2a, PudImg2b],
    imgAlt: "High-Power Water-Cooled Supply Modules",
  },
  {
    id: "aadcps",
    label: "Advanced AC-DC Power Supply Systems",
    images: [PudImg3],
    imgAlt: "Advanced AC-DC Power Supply Systems",
  },
];

const DpowProductsUnderDev = () => {
  const [activePud, setActivePud] = useState("dsc");
  const active = pudData.find(p => p.id === activePud);

  const handleTabClick = (id) => {
    setActivePud(id);
  };

  return (
    <section className="dpow-pud-section">
      <div className="dpow-inner">
        <div className="dpow-pud-row">

          {/* Image — always left, reuse ProductCarousel */}
          <div className="dpow-pud-left">
            <ProductCarousel images={active.images} name={active.id} />
          </div>

          {/* Content — always right */}
          <div className="dpow-pud-right">
            <h2 className="dpow-pud-heading">Products Under Development</h2>
            <p className="dpow-pud-tagline">Innovating For The Future Of Defence Power.</p>
            <p className="dpow-pud-desc">
              ADOR continues to invest in next-generation defence power technologies to support
              evolving mission requirements.
            </p>
            <div className="dpow-pud-list">
              {pudData.map(item => (
                <div
                  key={item.id}
                  className={`dpow-pud-item${activePud === item.id ? " dpow-pud-item--active" : ""}`}
                  onClick={() => handleTabClick(item.id)}
                >
                  {item.label}
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};
/* ── 6. Why Ador Powertron ── */
const DpowWhyAdor = () => (
  <section className="dpow-why-section">
    <div className="dpow-inner">
      <h2 className="dpow-why-heading">Why Ador Powertron</h2>
      <div className="dpow-why-grid">
        {whyPoints.map((pt, idx) => (
          <div className="dpow-why-card" key={idx}>{pt}</div>
        ))}
      </div>
    </div>
  </section>
);

/* ── 7. Trusted By Leading Defence Organizations ── */
const DpowTrustedBy = () => (
  <section className="dpow-trusted-section">
    <div className="dpow-inner">
      <h2 className="dpow-trusted-heading">Trusted by Leading Defence Organizations</h2>
      <p className="dpow-trusted-sub">
        Our solutions are deployed across strategic Defence programs in collaboration with leading
        Defence organizations, public-sector units and system integrators.
      </p>

      {/* ── Row 1: 5 cols ── */}
      <div className="dpow-logo-row">
        <div className="dpow-logo-col">
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-army-ord" src={LogoArmyOrd} alt="Army Ordnance"/>
          </div>
        </div>
        <div className="dpow-logo-col">
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-bel" src={LogoBel} alt="Bharat Electronics"/>
          </div>
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-accurate" src={LogoAccurate} alt="Accurate Energy"/>
          </div>
        </div>
        <div className="dpow-logo-col">
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-bsf" src={LogoBsf} alt="BSF"/>
          </div>
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-rdso" src={LogoRdso} alt="RDSO"/>
          </div>
        </div>
        <div className="dpow-logo-col">
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-ecil" src={LogoEcil} alt="ECIL"/>
          </div>
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-dh-ltd" src={LogoDhLtd} alt="DH Limited"/>
          </div>
        </div>
        <div className="dpow-logo-col">
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-navy" src={LogoNavy} alt="Indian Navy"/>
          </div>
        </div>
      </div>

      {/* ── Row 2: 7 equal single logo cards ── */}
      <div className="dpow-logo-row row-7">
        {[
          { img: LogoNfc,   alt: "NFC",   cls: "dpow-logo-nfc"   },
          { img: LogoVecc,  alt: "VECC",  cls: "dpow-logo-vecc"  },
          { img: LogoRrcat, alt: "RRCAT", cls: "dpow-logo-rrcat" },
          { img: LogoBarc,  alt: "BARC",  cls: "dpow-logo-barc"  },
          { img: LogoDrdo,  alt: "DRDO",  cls: "dpow-logo-drdo"  },
          { img: LogoHemrl, alt: "HEMRL", cls: "dpow-logo-hemrl" },
          { img: LogoLt,    alt: "L&T",   cls: "dpow-logo-lt"    },
        ].map((l, idx) => (
          <div className="dpow-logo-col" key={idx}>
            <div className="dpow-logo-card">
              <img className={`dpow-logo-img ${l.cls}`} src={l.img} alt={l.alt}/>
            </div>
          </div>
        ))}
      </div>

      {/* ── Row 3: 5 cols ── */}
      <div className="dpow-logo-row">
        <div className="dpow-logo-col">
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-army" src={LogoArmy} alt="Indian Army"/>
          </div>
        </div>
        <div className="dpow-logo-col">
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-bhel" src={LogoBhel} alt="BHEL"/>
          </div>
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-ipr" src={LogoIpr} alt="IPR"/>
          </div>
        </div>
        <div className="dpow-logo-col">
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-clt" src={LogoClt} alt="Continuous Line Technology"/>
          </div>
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-elbit" src={LogoElbit} alt="Elbit Systems"/>
          </div>
        </div>
        <div className="dpow-logo-col">
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-reliance" src={LogoReliance} alt="Reliance"/>
          </div>
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-iai" src={LogoIai} alt="IAI"/>
          </div>
        </div>
        <div className="dpow-logo-col">
          <div className="dpow-logo-card">
            <img className="dpow-logo-img dpow-logo-airforce" src={LogoAirForce} alt="Indian Air Force"/>
          </div>
        </div>
      </div>
    </div>
  </section>
);

/* ── 8. Awards & Recognitions ── */
const DpowAwards = () => (
  <section className="dpow-awards-section">
    <div className="dpow-inner">
      <h2 className="dpow-awards-heading">Awards &amp; Recognitions</h2>
      <div className="dpow-awards-grid">
        {awards.map((aw, idx) => (
          <img key={idx} className="dpow-award-img" src={aw.img} alt={aw.alt}/>
        ))}
      </div>
    </div>
  </section>
);

/* ── 9. Quality Certifications ── */
const DpowCertifications = () => (
  <section className="dpow-cert-section">
    <div className="dpow-inner">
      <div className="dpow-cert-row">
        <div className="dpow-cert-label-col">
          <div className="dpow-cert-label-text">Quality Management<br/>Certifications</div>
        </div>
        <div className="dpow-cert-logos-col">

          {/* Row 1: AS, NQA, ISO 9001 (45001), ISO 14001 — gradient border below */}
          <div className="dpow-cert-row-group has-border">
            <div className="dpow-cert-logo-box"><img className="dpow-cert-img" src={CertAs}       alt="AS 9100:2016"/></div>
            <div className="dpow-cert-logo-box"><img className="dpow-cert-img" src={CertNqa}      alt="NQA ANAB ISO 9001"/></div>
            <div className="dpow-cert-logo-box"><img className="dpow-cert-img" src={CertIso9001a} alt="ISO 9001:2015"/></div>
            <div className="dpow-cert-logo-box"><img className="dpow-cert-img" src={CertIso14001} alt="ISO 14001:2015"/></div>
          </div>

          {/* Row 2: ISO 39001, ISO 27001, CMMI, BIS — gradient border below */}
          <div className="dpow-cert-row-group has-border">
            <div className="dpow-cert-logo-box"><img className="dpow-cert-img" src={CertIso39001} alt="ISO 39001:2012"/></div>
            <div className="dpow-cert-logo-box"><img className="dpow-cert-img" src={CertIso27001} alt="ISO 27001"/></div>
            <div className="dpow-cert-logo-box"><img className="dpow-cert-img" src={CertCmmi}     alt="CMMI Level 4"/></div>
            <div className="dpow-cert-logo-box"><img className="dpow-cert-img" src={CertBis}      alt="BIS"/></div>
          </div>

          {/* Row 3: CE, ISO 9001b, RoHS — no border */}
          <div className="dpow-cert-row-group">
            <div className="dpow-cert-logo-box"><img className="dpow-cert-img" src={CertCe}       alt="CE"/></div>
            <div className="dpow-cert-logo-box"><img className="dpow-cert-img" src={CertIso9001b} alt="ISO 9001:2015"/></div>
            <div className="dpow-cert-logo-box"><img className="dpow-cert-img" src={CertRohs}     alt="RoHS Compliant"/></div>
          </div>

        </div>
      </div>
    </div>
  </section>
);

/* ── 10. CTA Banner ── */
const DpowCtaBanner = () => (
  <section className="dpow-cta-section">
    <img className="dpow-cta-bg" src={CtaBgImg} alt="CTA Background"/>
    <div className="dpow-cta-overlay"/>
    {/* FIX: dpow-cta-inner constrains content to 1600px + 102px — same as dpow-inner */}
    <div className="dpow-cta-inner">
      <div className="dpow-cta-title">
        Partner with ADOR Powertron for mission-critical defence power solutions engineered
        for reliability, ruggedness &amp; operational excellence.
      </div>
      <div className="dpow-cta-btns">
        <a href="#" className="dpow-btn-primary">Discuss Your Defence Power Requirement</a>
        <a href="#" className="dpow-btn-outline">Download Defence Solutions Brochure</a>
      </div>
    </div>
  </section>
);

/* ── 11. Get In Touch ── */
const DpowContact = () => (
  <section className="dpow-contact-section" id="contact">
    <div className="dpow-inner">
      <div className="dpow-contact-row">

        {/* Left — heading + contact details */}
        <div className="dpow-contact-left">
          <h2 className="dpow-contact-heading">Get In Touch</h2>
          <p className="dpow-contact-tagline">
            Don't Hesitate To Contact Us For More Information About The Product Or Services.
          </p>
          <div className="dpow-contact-detail">
            <PinIcon/>
            <div className="dpow-contact-detail-text">
              Ador Warrior City Campus, Plot No. 51, D-II Block,<br/>
              Ramnagar, MIDC, Chinchwad, Pune,<br/>
              Maharashtra 411019
            </div>
          </div>
          <div className="dpow-contact-detail">
            <PhoneIcon/>
            <div className="dpow-contact-detail-text">+91 9158885441</div>
          </div>
          <div className="dpow-contact-detail">
            <MailIcon/>
            <div className="dpow-contact-detail-text">mktgsps@adorpower.com</div>
          </div>
        </div>

        {/* Right — form in white card */}
        <div className="dpow-contact-right">
          <div className="dpow-form-row">
            <input className="dpow-form-input" type="text"  placeholder="Name"/>
            <input className="dpow-form-input" type="text"  placeholder="Company"/>
          </div>
          <div className="dpow-form-row">
            <input className="dpow-form-input" type="tel"   placeholder="Phone Number"/>
            <input className="dpow-form-input" type="email" placeholder="Email"/>
          </div>
          <input
            className="dpow-form-input"
            type="text"
            placeholder="Subject"
            style={{ display: "block", width: "100%", marginBottom: "16px" }}
          />
          <textarea className="dpow-form-textarea" placeholder="Message"/>
          <button className="dpow-btn-submit">Submit</button>
        </div>

      </div>
    </div>
  </section>
);

/* ═══════════════════════════════════════════
   MAIN PAGE COMPONENT
═══════════════════════════════════════════ */
export default function AdorDefencePower() {
  const [activeTab, setActiveTab] = useState("ups");

  return (
    <div className="dpow">
      <style>{CSS}</style>

      {/* 1. Hero */}
      <DpowHero/>

      {/* 2. Breadcrumb */}
      <DpowBreadcrumb/>

      {/* 3. About Defence Division */}
      <DpowAbout/>

      {/* 4. Product Tabs */}
      <DpowProductTabs activeTab={activeTab} setActiveTab={setActiveTab}/>

      <div className="dpow-divider-wrap"><hr className="dpow-divider"/></div>

      {/* 5. Products Under Development */}
      <DpowProductsUnderDev/>

      <div className="dpow-divider-wrap"><hr className="dpow-divider"/></div>

      {/* 6. Why Ador Powertron */}
      <DpowWhyAdor/>

      <div className="dpow-divider-wrap"><hr className="dpow-divider"/></div>

      {/* 7. Trusted By Leading Defence Organizations */}
      <DpowTrustedBy/>

      <div className="dpow-divider-wrap"><hr className="dpow-divider"/></div>

      {/* 8. Awards & Recognitions */}
      <DpowAwards/>

      <div className="dpow-divider-wrap" ><hr className="dpow-divider"/></div>

      {/* 9. Quality Certifications */}
      <DpowCertifications/>

      {/* 10. CTA Banner */}
      <DpowCtaBanner/>

      {/* 11. Get In Touch */}
      <DpowContact/>

    </div>
  );
}